<lib-page-layout>
  <lib-title-navbar pageHeader title="Gierki pod tym adresem"></lib-title-navbar>

  @if (locationDetails(); as details) {
    <div class="or-h-100-pc">
      <div class="or-d-flex or-align-items-center or-mt-16-px or-mx-16-px">
        <or-icon name="location" size="s" circle class="or-mr-8-px" />

        <div>
          <div class="or-head-sm or-color-primary-2">Adres</div>
          <div class="or-head-md">{{ details.name }} ({{ details.address }})</div>
        </div>
      </div>

      <div class="or-d-flex or-justify-content-center">
        <div class="custom-divider-location-details or-my-16-px"></div>
      </div>

      <div class="disable-scroll">
        @if (details.todayGames.length) {
          <div class="or-text-lg or-ml-16-px">Dzisiejsze</div>
        }
        @for (game of details.todayGames; track game.gameId) {
          <div class="or-my-12-px">
            <lib-game-card-v2
              (click)="openDetails(game); $event.stopPropagation()"
              [game]="game"
              [badgeMode]="badgeMode.PLAYER"
              [showHostDetails]="true"></lib-game-card-v2>
          </div>
        }
        @if (details.todayGames.length) {
          <div class="or-d-flex or-justify-content-center">
            <div class="custom-divider-location-details or-mb-16-px"></div>
          </div>
        }
        @if (details.futureGames.length) {
          <div class="or-text-lg or-ml-16-px">Pozostałe</div>
        }
        @for (game of details.futureGames; track game.gameId) {
          <div class="or-my-12-px">
            <lib-game-card-v2
              (click)="openDetails(game); $event.stopPropagation()"
              [game]="game"
              [badgeMode]="badgeMode.PLAYER"
              [showHostDetails]="true"></lib-game-card-v2>
          </div>
        }
      </div>
    </div>
  }

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
